<template>
  <div>
    <Nav></Nav>

    <mdb-container class="page-title pt-4">
      <mdb-row class="mb-4">
        <mdb-col md="12" class="text-left">
          <h1>Masterclass</h1>
          <p>Sales videos and guides to get you selling faster</p>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="home-section tile-courses">
      <mdb-row>
        <mdb-col md="6" xl="4" class="d-flex mb-4">
          <router-link to="/course/How-to-find-clients" class="bg-find">
            <!-- first card -->
            <mdb-card class="box-gradient-white-2 top-bar-green">
              <mdb-badge pill color="bg-green" class="cat-badge">
                <mdb-icon icon="video" />COURSE
              </mdb-badge>
              <mdb-card-body class="d-flex flex-column">
                <mdb-card-title class="mt-5">How to find clients</mdb-card-title>
                <mdb-card-text
                  class="mb-2"
                >Learn how to build your ideal clients, where to find them and how to engage with them</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span
                  class="lesson-count"
                >{{mthGetNumberOfLessonsByCoursename('How to find clients')}} lessons</span>
                <mdb-progress
                  :height="5"
                  :value="mthGetProgress('How to find clients')"
                  class="mt-2 mr-2"
                />
                {{mthGetProgress("How to find clients")}}%
                <span class="learn">
                  {{mthWordStartOrContinueByProgress('How to find clients')}} Learning
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col md="6" xl="4" class="d-flex mb-4">
          <router-link
            to="/course/How-to-sell-and-win"
            style="background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/new-01.jpg'); 	background-position: center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;"
          >
            <!-- second card -->
            <mdb-card class="box-gradient-white-2 top-bar-green">
              <mdb-badge pill color="bg-green" class="cat-badge">
                <mdb-icon icon="video" />COURSE
              </mdb-badge>
              <mdb-card-body class="d-flex flex-column">
                <mdb-card-title class="mt-5">How to sell & win</mdb-card-title>
                <mdb-card-text
                  class="mb-2"
                >Master the critical sales steps of planning, engaging with clients, crafting compelling sales proposals, negotiating, closing and follow up</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span
                  class="lesson-count"
                >{{mthGetNumberOfLessonsByCoursename('How to sell and win')}} lessons</span>
                <mdb-progress
                  :height="5"
                  :value="mthGetProgress('How to sell and win')"
                  class="mt-2 mr-2"
                />
                {{mthGetProgress("How to sell and win")}}%
                <span class="learn">
                  {{mthWordStartOrContinueByProgress('How to sell and win')}} Learning
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col md="6" xl="4" class="d-flex mb-4">
          <router-link
            to="/course/How-to-sell-more"
            style="background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/more-01.jpg'); 	background-position: center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;"
          >
            <!-- third card -->
            <mdb-card class="box-gradient-white-2 top-bar-green">
              <mdb-badge pill color="bg-green" class="cat-badge">
                <mdb-icon icon="video" />COURSE
              </mdb-badge>
              <mdb-card-body class="d-flex flex-column">
                <mdb-card-title class="mt-5">How to sell more</mdb-card-title>
                <mdb-card-text
                  class="mb-2"
                >Practical guidance to help to stay ahead of the competition and build deeper relationships to sell more with confidence</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span
                  class="lesson-count"
                >{{mthGetNumberOfLessonsByCoursename('How to sell more')}} lessons</span>
                <mdb-progress
                  :height="5"
                  :value="mthGetProgress('How to sell more')"
                  class="mt-2 mr-2"
                />
                {{mthGetProgress("How to sell more")}}%
                <span class="learn">
                  {{mthWordStartOrContinueByProgress('How to sell more')}} Learning
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import firebase from "firebase/app";
import { store } from "../store";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress
} from "mdbvue";

export default {
  name: "Sell",
  created() {},
  data() {
    return {
      courses: [], //used for progress presenting
      progressTrackingOfMine: [] //used for progress presenting
    };
  },
  methods: {
    mthWordStartOrContinueByProgress(coursename) {
      var toret = "Start";

      var progress = this.mthGetProgress(coursename);

      if (progress > 1) toret = "Continue";

      return toret;
    },
    mthGetNumberOfLessonsByCoursename(coursename) {
      var toret = 0;

      this.courses.forEach(c => {
        //console.log(c)

        //var counter = 0;

        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          //toret = c.firedata.newOrEditedCourseDetails.length;

          c.firedata.newOrEditedCourseDetails.forEach(element => {
            if (element.type == "video" || element.type == "text") {
              toret++;
            }
          });
        }
      });
      return toret;
    },
    mthGetProgress(coursename) {
      var toret = 0.001;

      var licznik = this.mthGetSumOfVideosProgressesByCoursname(coursename);
      var mianownik = this.mthGetCourseTotalMinutesByName(coursename);

      if (mianownik === 0) return 0;
      if (licznik < 5) return 0;

      //console.log("licznik: " + licznik);
      //console.log("mianownik: " + mianownik);

      toret = (licznik * 100) / mianownik;

      if (toret > 98) return 100;
      if (toret < 0) return 0;

      toret = Math.round(toret);

      return toret;
    },
    mthGetSumOfVideosProgressesByCoursname(coursename) {
      var toret = 0.00000001;

      this.progressTrackingOfMine.forEach(t => {
        //console.log(t.firedata);

        if (t && t.firedata && t.firedata.courseslug && t.firedata.event) {
          let cname = t.firedata.courseslug
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ");
          if (cname === coursename && t.firedata.event.seconds)
            toret += t.firedata.event.seconds;
        }
      });

      return toret;
    },
    mthGetCourseTotalMinutesByName(coursename) {
      let totalminutes = 0; //to not divide by 0 ;)
      //console.log('arg is'+coursename)

      this.courses.forEach(c => {
        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          c.firedata.newOrEditedCourseDetails.forEach(d => {
            if (d.type && d.type === "video") {
              if (d && d.data && d.data.data && d.data.data.vimeoduration) {
                totalminutes += d.data.data.vimeoduration;
              }
            }
          });
        }
      });

      return totalminutes;
    },
    mthFillProgressTrackingOfMine() {
      var refProgressTracking = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.$store.getters.getUser.email);

      refProgressTracking.onSnapshot(querySnapshot => {
        this.progressTrackingOfMine = [];
        querySnapshot.forEach(doc => {
          this.progressTrackingOfMine.push({
            firedata: doc.data()
          });
        });
        //console.log(this.progressTrackingOfMine);
      });

      return 0.001;
    },
    mthFillCourses() {
      var refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        this.courses = [];
        querySnapshot.forEach(doc => {
          this.courses.push({
            firedata: doc.data()
          });
        });
        //console.log(this.courses);
      });
    },

    mthGetUserNickOrEmailTheWordAfterHiFromStore() {
      let ret = "Guest";

      if (
        this.$store.getters.getNickname !== null &&
        this.$store.getters.getNickname !== undefined &&
        this.$store.getters.getNickname !== ""
      )
        ret = this.$store.getters.getNickname;

      if (ret === "Guest") {
        if (
          this.$store.getters.getUser !== null &&
          this.$store.getters.getUser.email !== null &&
          this.$store.getters.getUser.email !== undefined &&
          this.$store.getters.getUser.email !== ""
        )
          ret = this.$store.getters.getUser.email.split("@")[0];
      }

      return ret;
    }
  },
  created() {
    this.mthFillCourses();

    this.mthFillProgressTrackingOfMine();
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbProgress
  }
};
</script>

<style>
</style>
